export const DESIGNER_COMPONENTS: IDesignerComponents[] = [
    {
        group: "layout",
        name: "Layout",
        sortableGroup: "layout",
        items: [
            {
                name: "Row",
                icon: "container",
                schema: "row",
            },
            {
                name: "Container",
                icon: "container",
                schema: "container",
            },
            {
                name: "Page Content",
                icon: "container",
                schema: "page-content",
            },
            {
                name: "Pure Content",
                icon: "container",
                schema: "pure-content",
            },
            {
                name: "Content Restrictive",
                icon: "container",
                schema: "content-restrictive",
            },
            {
                name: "12/12",
                icon: "md-12",
                schema: "column",
                description: "Yalnızca <strong>genel içerik, layout container</strong> ya da <strong>column</strong> sürükleyebilirsiniz",
                size: 12,
            },
            {
                name: "9/12",
                icon: "md-9",
                schema: "column",
                size: 9,
                description: "Yalnızca <strong>genel içerik, layout container</strong> ya da <strong>column</strong> sürükleyebilirsiniz",
            },
            {
                name: "8/12",
                icon: "md-8",
                schema: "column",
                size: 8,
                description: "Yalnızca <strong>genel içerik, layout container</strong> ya da <strong>column</strong> sürükleyebilirsiniz",
            },
            {
                name: "6/12",
                icon: "md-6",
                schema: "column",
                size: 6,
                description: "Yalnızca <strong>genel içerik, layout container</strong> ya da <strong>column</strong> sürükleyebilirsiniz",
            },
            {
                name: "4/12",
                icon: "md-4",
                schema: "column",
                size: 4,
                description: "Yalnızca <strong>genel içerik, layout container</strong> ya da <strong>column</strong> sürükleyebilirsiniz",
            },
            {
                name: "3/12",
                icon: "md-3",
                schema: "column",
                size: 3,
                description: "Yalnızca <strong>genel içerik, layout container</strong> ya da <strong>column</strong> sürükleyebilirsiniz",
            },
            {
                name: "Section",
                icon: "section",
                schema: "section",
                description: "Yalnızca <strong>genel içerik, layout container</strong> ya da <strong>column</strong> sürükleyebilirsiniz",
            },
            {
                name: "Scrollbar",
                icon: "section",
                schema: "scrollbar",
                description: "Yalnızca <strong>genel içerik, layout container</strong> ya da <strong>column</strong> sürükleyebilirsiniz",
            }
        ],
    },
    {
        group: "content",
        name: "Genel İçerikler",
        sortableGroup: "droppable",
        items: [
            {
                name: "Accordion",
                icon: "button",
                schema: "accordion",
                description: "Accordion componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "List",
                icon: "button",
                schema: "list",
                description: "Liste componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Button",
                icon: "button",
                schema: "button",
                description: "Button componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Card Filter",
                icon: "button",
                schema: "card-filter",
                description: "card filter componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Title",
                icon: "heading",
                schema: "heading",
                description: "Title componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Paragraph",
                icon: "paragraph",
                schema: "paragraph",
                description: "Paragraph componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Icon",
                icon: "icon",
                schema: "icon",
                description: "Icon componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Icon List",
                icon: "iconlist",
                schema: "icon-list",
                description: "Icon List componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "HTML",
                icon: "html",
                schema: "html",
                description: "HTML componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "CSS Style",
                icon: "button",
                schema: "style",
                description: "CSS Style componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Image",
                icon: "image",
                schema: "image",
                description: "Image componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Photo Gallery",
                icon: "fancybox",
                schema: "photo-gallery",
                description: "Photo Gallery componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Photo Gallery Full",
                icon: "fancybox",
                schema: "photo-gallery-full",
                description: "Photo Gallery Full componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Video",
                icon: "video",
                schema: "video",
                description: "Video componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Iframe",
                icon: "iframe",
                schema: "iframe",
                description: "Iframe componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Seperator",
                icon: "horizantalrule",
                schema: "horizontal-rule",
                description: "Seperator componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Slideshow",
                icon: "slideshow",
                schema: "slideshow",
                description: "Slideshow componentinin açıklaması bulunmamaktadır."
            },
        ],
    },
    {
        group: "custom",
        name: "Özel Bileşenler",
        sortableGroup: "droppable",
        items: [
            {
                name: "Header",
                icon: "header",
                schema: "header",
                description: "Header componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Footer",
                icon: "footer",
                schema: "footer",
                description: "Footer componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Card",
                icon: "card",
                schema: "card",
                description: "Card componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Card List",
                icon: "cardlist",
                schema: "card-list",
                description: "Card List componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Full Card List",
                icon: "cardlist",
                schema: "full-card-list",
                description: "Full Card List componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Announcement List",
                icon: "cardlist",
                schema: "announcement-list",
                description: "Announcement List componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Arşiv Event Card List",
                icon: "cardlist",
                schema: "archive-event-card-list",
                description: "Arşiv Event Card List componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Event Card List",
                icon: "cardlist",
                schema: "event-card-list",
                description: "Event Card List componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Card Slider",
                icon: "slideshow",
                schema: "card-slider",
                description: "Card Slider componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Event Slider",
                icon: "slideshow",
                schema: "event-slider",
                description: "Etkinlik slider'ı tanımı içindir."
            },
            {
                name: "Event Card Slider",
                icon: "slideshow",
                schema: "event-card-slider",
                description: "Etkinlik card slider'ı tanımı içindir."
            },
            {
                name: "Event Detail",
                icon: "container",
                schema: "event-detail",
                description: "Etkinlik detay tanımı içindir"
            },
            {
                name: "Event Page",
                icon: "container",
                schema: "event-page",
                description: "Event page componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Book Now",
                icon: "card",
                schema: "book-now",
                description: "Book Now componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Corporate Buttons",
                icon: "button",
                schema: "corporate-buttons",
                description: "Corporate Buttons componentinin tanımı içindir."
            },
            {
                name: "Instagram",
                icon: "socialmedia",
                schema: "instagram",
                description: "Instagram componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Redirection",
                icon: "button",
                schema: "redirect",
                description: "Redirection componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Content Grid",
                icon: "button",
                schema: "content-grid",
                description: "Content Grid componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Hero",
                icon: "section",
                schema: "hero",
                description: "Banner şeklinde kullanılabilen resim ve yazı elementlerinden oluşan component"
            },
            {
                name: "Page Title",
                icon: "heading",
                schema: "page-title",
                description: "İç sayfalarda üst başlık ve sosyal medya ayarı"
            },
            {
                name: "Hero Slider",
                icon: "section",
                schema: "hero-slider",
                description: "Banner şeklinde kullanılabilen resim ve yazı elementlerinden oluşan component"
            },
            {
                name: "Culture Road",
                icon: "card",
                schema: "culture-road",
                description: "Beyoğlu Kültür Yolu SVG Haritası İçerikleri"
            },
            {
                name: "Culture Road V2",
                icon: "card",
                schema: "culture-road-v2",
                description: "Beyoğlu Kültür Yolu SVG Haritası İçerikleri"
            },
            {
                name: "Subscribe",
                icon: "card",
                schema: "subscribe",
                description: "Haberin Olsun Newsletter"
            },
            {
                name: "Subscribe Out",
                icon: "card",
                schema: "subscribeOut",
                description: "Haberin Olsun Newsletter Eposta İle Delete"
            },
            {
                name: "Instagram",
                icon: "socialmedia",
                schema: "instagram",
                description: "Instagram componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Digital Scene",
                icon: "card",
                schema: "digital-scene",
                description: "Dijital Sahne İçeriği"
            },
            {
                name: "Venue Rental",
                icon: "card",
                schema: "venue-rental",
                description: "Mekan Kiralama Formu"
            },
            {
                name: "Contact Us",
                icon: "card",
                schema: "contact-us",
                description: "Bize Ulaşın"
            },
            {
                name: "Venue Detail",
                icon: "card",
                schema: "venue-detail",
                description: "Mekan Detayları"
            },
            {
                name: "Venue Rental Accordion",
                icon: "card",
                schema: "venue-rental-accordion",
                description: "Mekan Kiralama Accordion"
            },
            {
                name: "Member Ship",
                icon: "card",
                schema: "membership",
                description: "üyelik ve kayıt componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Video Slider",
                icon: "video",
                schema: "video-slider",
                description: "Video Slider Gallery"
            },
            {
                name: "Kurumsal",
                icon: "card",
                schema: "corporation",
                description: "Kurumların İçerik"
            },
            {
                name: "Sesli 360 Derece",
                icon: "card",
                schema: "threed-with-audio",
                description: "Kültür sokağı İçerik"
            },
            {
                name: "Sesli İç İçe İçerik ",
                icon: "card",
                schema: "multiple-accordion-with-audio",
                description: "Kültür sokağı İçerik"
            },
            {
                name: "Instagram Slider",
                icon: "card",
                schema: "social-media-slider",
                description: "Son Instagram postlarının olduğu slider"
            },
            {
                name: "Kurumsal Zaman Çizgisi",
                icon: "card",
                schema: "corporate-timeline",
                description: "Kurumsal zaman çizgisi yıllara göre ayırmak için kullanılır"
            },
            {
                name: "Müzik Platformu Sesli İçerik",
                icon: "card",
                schema: "music-platform-audio",
                description: "Müzik platformunu sunumu"
            },
            {
                name: "Mobile Instruments",
                icon: "card",
                schema: "mobile-instruments",
                description: "Mobile özel QR Kod ile gidilen çalgı aletleri sayfası."
            },
            {
                name: "Playlist",
                icon: "card",
                schema: "playlist",
                description: "Mobile özel QR Kod ile gidilen çalma listesi componenti"
            },
            {
                name: "Mobile Instrument Categories",
                icon: "card",
                schema: "mobile-instruments-categories",
                description: "Mobile özel QR Kod ile gidilen çalgı aletleri kategorileri."
            },
            {
                name: "Google Maps",
                icon: "card",
                schema: "google-maps",
                description: "Özelleştirilmiş Google Maps."
            },
            {
                name: "Duyuru Penceresi",
                icon: "card",
                schema: "popup-announcement",
                description: "Ekranda duyuru vermek için kullanır."
            },
            {
                name: "Mobile Instruments List",
                icon: "card",
                schema: "mobile-instruments-list",
                description: "Mobile özel QR Kod ile gidilen çalgı aletleri liste sayfası."
            },
            {
                name: "Akıllı Bilgi Kutu Listesi",
                icon: "container",
                schema: "smart-infobox-list",
                description: "Anasayfada kullanılan ve kendi detay bilgilerini içerisinde gösteren akıllı bilgi kutu listesi."
            },
            {
                name: "Yerleşim Planı",
                icon: "container",
                schema: "settlement-plan",
                description: "Yerleşim plan haritası."
            },
            {
                name: "Image Popup",
                icon: "image",
                schema: "image-popup",
                description: "Image popup bileşeni"
            },
            {
                name: "Art Children Event List",
                icon: "cardlist",
                schema: "art-festival-event-list",
                description: "Art Children Event List Component"
            },
            {
                name: "Art Children Gallery",
                icon: "cardlist",
                schema: "art-children-gallery",
                description: "Art Children Gallery Component"
            },
            {
                name: "Yarışma Detay",
                icon: "cardlist",
                schema: "competition",
                description: "Yarışma Detay Component"
            },
            {
                name: "Music Recording Studio Form",
                icon: "cardlist",
                schema: "music-recording-studio-form",
                description: "Music Recording Studio Form Component"
            },
            {
                name: "Etkinlik Takvimi",
                icon: "cardlist",
                schema: "event-calendar",
                description: "Etkinlik Takvimi componentinin açıklaması bulunmamaktadır."
            }
        ],
    },
    {
        group: "account",
        name: "Üyelik Sistemi",
        sortableGroup: "droppable",
        items: [
            {
                name: "Kullanıcı Doğrulama",
                icon: "section",
                schema: "authentication",
                description: "Kullanıcı Doğrulama componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Giriş Yap",
                icon: "header",
                schema: "sign-in",
                description: "Giriş yap componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Üye Ol",
                icon: "header",
                schema: "sign-up",
                description: "Üye ol componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Şifremi Unuttum",
                icon: "header",
                schema: "forgot-password",
                description: "Şifremi unuttum componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Randevu Formu",
                icon: "header",
                schema: "library-appointment",
                description: "Randevu Formu componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Hesap - Profil Bilgilerim",
                icon: "header",
                schema: "account-profile",
                description: "Hesap - Profil Bilgilerim componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Hesap - Randevularım",
                icon: "header",
                schema: "account-appointments",
                description: "Hesap - Randevularım componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Hesap - Telefon Numarası",
                icon: "header",
                schema: "account-phone",
                description: "Hesap - Telefon Numarası componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Hesap - E-Mail",
                icon: "header",
                schema: "account-email",
                description: "Hesap - E-Mail componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Hesap - Parola",
                icon: "header",
                schema: "account-password",
                description: "Hesap - Parola componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "Hesap - Sidebar",
                icon: "header",
                schema: "account-sidebar",
                description: "Hesap - Sidebar componentinin açıklaması bulunmamaktadır."
            },
            {
                name: "QR Code",
                icon: "header",
                schema: "qr-code",
                description: "QR Code componentinin açıklaması bulunmamaktadır."
            },
        ],
    }
];

export interface IDesignerItems {
    name: string;
    icon: string;
    schema: string;
    size?: number,
    description?: string
}

export interface IDesignerComponents {
    group: string;
    name: string;
    sortableGroup: string;
    items: IDesignerItems[];
}